<template>
    <div class="app-status-bar border-bottom py-25 d-flex justify-content-end align-items-center">
        <!-- <b-dropdown v-if="isHR" boundary="viewport" variant="light" right no-caret toggle-tag="div" :toggle-class="['status-bar-netsis-info pr-1',{'has-error':hasError}]" menu-class="p-0 status-bar-netsis-info-menu" :disabled="netsisLoading">
            <template #button-content>
                <feather-icon icon="AlertCircleIcon" class="mr-50" v-if="hasError && !netsisLoading"></feather-icon>
                <span class="font-weight-bolder">Netsis</span>
            </template>
            <h5 class="mx-1 mt-75 mb-0 font-weight-bolder">Netsis Bilgileri</h5>
            <div class="alert mt-50 mx-50 mb-50" :class="hasError ? 'alert-warning' : 'alert-success'" v-if="$safe(netsisResult,'Information')">
                <div class="alert-body p-75">
                    {{ $safe(netsisResult,'Information') }}
                </div>
            </div>
            <template v-if="($safe(netsisResult,'Errors')||[]).length > 0">
                <ul class="list-group mx-50 mb-50">
                    <li class="list-group-item px-50 py-25 text-secondary" v-for="(e,i) in ($safe(netsisResult,'Errors')||[])" :key="i">
                        {{e}}
                    </li>
                </ul>
            </template>
        </b-dropdown> -->
        <span class="font-weight-bolder pl-1">{{ time }}</span>
    </div>
</template>

<script>
import moment from 'moment'
import NetsisApi from '@/api/hr-netsis'
import { BDropdown } from 'bootstrap-vue'
import Auth from '@/utilities/auth'

export default {
    components:{
        BDropdown
    },
    data(){
        return {
            time:null,
            netsisLoading:true,
            netsisResult:null,
        }
    },
    mounted(){
        this.startClock()
        if(this.isHR){
            this.checkNetsisTarhi()
        }
    },
    methods:{
        startClock(){
            const showTime = () => {
                this.time = moment().locale('tr').format('DD.MM.YYYY dddd HH:mm')
                setTimeout(showTime, 1000);
            }
            showTime();
        },
        checkNetsisTarhi(){
            // NetsisApi.CheckCurrentTarih().then(res=>{
            //     if(res.data.Success){
            //         this.netsisLoading = false
            //         this.netsisResult = res.data.Data
            //     }
            // })
        }
    },
    computed:{
        hasError(){
            if(this.netsisResult?.Information != null){
                if((this.netsisResult?.Errors || []).length == 0){
                    return false
                }else return true
            } else return true
        },
        isHR(){
            return Auth.isHR
        }
    }
}
</script>

<style>
.app-status-bar{
    margin-top: -2rem;
    margin-left: -2rem;
    margin-right: -2rem;
    margin-bottom: 1rem;
    padding-right: 2rem;
    background-color: #fff;
}

.dark-layout .app-status-bar{
    background-color: #283046;
}

.status-bar-netsis-info{
    background-color: transparent !important;
    color: inherit !important;
    padding: 0px;
    border: 0;
}

.status-bar-netsis-info:not(.disabled):not(.has-error){
    color: var(--success) !important;
}

.status-bar-netsis-info:not(.disabled).has-error{
    color: var(--danger) !important;
}

.status-bar-netsis-info-menu{
    max-width: 320px;
}
</style>